
export const SET_MSG = 'CARTAOPONTO_MSG';
export const SET_EDITAR = 'CARTAOPONTO_EDITAR';
export const SET_LISTA = 'CARTAOPONTO_LISTA';
export const SET_BOLETINS = 'CARTAOPONTO_BOLETINS';
export const SET_HORARIOS = 'CARTAOPONTO_HORARIOS';